import React, { useState } from 'react';
import InvestorMailboxContentSC, {
  TopContentWrapSC,
  BottomContentWrapSC,
  EmptySC,
} from './investor-mailbox-content.styled';
import SectionSwitch from './section-switch';
import MailboxTable from './mailbox-table';
import DocumentsTable from './documents-table';
import { SmallText } from '../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import RequestsTable from './requests-table';
import MailboxReports from './mailbox-reports';
import { connect } from 'react-redux';

const TABS = [
  {
    label: 'investor_mailbox_section_documents',
    name: 'documents',
    acl: [],
  },
  // {
  //   label: 'investor_mailbox_section_messages_borrower',
  //   name: 'messages-borrower',
  //   acl: [],
  // },
  {
    label: 'investor_mailbox_section_messages_investor',
    name: 'messages-investor',
    acl: [],
  },
  {
    label: 'investor_mailbox_section_requests',
    name: 'requests',
    acl: [],
  },
  {
    label: 'investor_mailbox_section_reports',
    name: 'reports',
    acl: ['investor'],
  },
  {
    label: 'investor_mailbox_section_sms',
    name: 'emails',
    acl: [],
  },
];

const _InvestorMailboxContent = ({ userType }) => {
  const [isActive, setIsActive] = useState('documents');
  const categories = React.useMemo(
    () => TABS.filter((t) => (t.acl.length > 0 ? t.acl.includes(userType) : true)),
    [userType]
  );

  const renderedSection = React.useMemo(() => {
    switch (isActive) {
      case 'messages-investor':
        return (
          <EmptySC>
            <div className="empty-table">
              <SmallText className="black-transparent bold">
                <FormattedMessage
                  id="mailbox_investor_message_empty"
                  defaultMessage={dlt['mailbox_investor_message_empty']}
                />
              </SmallText>
            </div>
          </EmptySC>
        );
      case 'messages-borrower':
        return (
          <EmptySC>
            <div className="empty-table">
              <SmallText className="black-transparent bold">
                <FormattedMessage
                  id="mailbox_borrower_message_empty"
                  defaultMessage={dlt['mailbox_borrower_message_empty']}
                />
              </SmallText>
            </div>
          </EmptySC>
        );
      case 'documents':
        return <DocumentsTable />;
      case 'requests':
        return <RequestsTable />;
      case 'emails':
        return <MailboxTable type="emails" />;
      case 'reports':
        return <MailboxReports />;
      default:
        return null;
    }
  }, [isActive]);

  return (
    <InvestorMailboxContentSC>
      <TopContentWrapSC>
        <SectionSwitch
          categories={categories}
          isActive={isActive}
          setActiveCategory={setIsActive}
        />
      </TopContentWrapSC>
      <BottomContentWrapSC>{renderedSection}</BottomContentWrapSC>
    </InvestorMailboxContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    userType: state.user.type,
  };
};

export default connect(mapStateToProps)(React.memo(_InvestorMailboxContent));
